import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Col, Input, Row, Select } from "antd";
import { ProxyColumns } from "./Columns";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import useGet from "../../../global/hooks/useGet";
import useDelete from "../../../global/hooks/useDelete";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import ConfirmModal from "../../../global/components/ConfirmModal";
import { GlobalTable } from "./../../../global/components/GlobalTable";
import downloadCsv from "../../../global/utils/downloadCsv";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
const initialFilterState = {
  ProxyNo: "",
  ProxyPort: "",
  ProxyAddr: "",
  Address: "",
  ProxyType: "",
  // SiteType: null,
};

export const Proxy = () => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [listData, setListData] = useState([]);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "ProxyNo",
    order: "asc",
  }); //
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  }; //
  const [pagination, setPagination] = useState(initialPagination);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filter, setFilter] = useState(initialFilterState);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [showModal, setShowModal] = useState(false);

  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "Proxy Server",
      href: "/proxyserver",
    },
  ];

  // const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;

  // const {
  //   data: optionsData,

  //   error: optionDataError,
  // } = useGet(optionUrl);

  // const modifiedSiteTypes = getModifiedResponse(optionsData, "sitetype");

  // to get table data from API server
  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();
  // console.log(query);
  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/proxy-servers/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/proxy-servers/`;
  const { data, loading, error, refetch } = useGet(url);
  const ProxyTypeOptions = [
    { label: "On Premise", value: 0 },
    { label: "Cloud Site", value: 1 },
  ];

  // console.log({ data });
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/proxy-servers/bulk-delete/`;
  // selectedRowKeys.length > 1
  //   ? (deleteUrl = `${process.env.REACT_APP_API_URL}/api/proxyservers/bulk-delete/`)
  //   : (deleteUrl = `${process.env.REACT_APP_API_URL}/api/proxyservers/delete/${selectedRowKeys}/`);
  // const exportSips = `${process.env.REACT_APP_API_URL}/api/proxyservers/export`;
  // const { data: exportData, refetch: refetchExport } = useGet(exportSips);

  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    deleteMultiple,
  } = useDelete(deleteUrl);

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []); //

  const paginationConfig = {
    current: pagination.current, //current page
    pageSize: pagination.pageSize, // items per page
    total: data?.count, // total items
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
    // navigate(`/oemlist/${newSelectedRowKeys}`);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };

  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        navigate(`/proxyserver/info/${record?.ProxyNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (e) => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        filterDict[key] = filter[key];
      }
    }

    const isEmpty = JSON.stringify(filterDict) === "{}";

    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "ProxyNo",
        order: "desc",
        page: 1,
        ...filterDict,
      };
      setPagination((prev) => ({ ...prev, current: 1 }));
      setParams(params);
      refetch();
    }
  };

  // reset
  const handleReset = (e) => {
    // Reset the filter state to the initial state
    setFilter({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    // Define the new parameters for the API call
    const params = {
      limit: 10,
      sort_by: "ProxyNo", // Make sure to specify sorting if necessary
      order: "desc",
    };
    setParams(params);
    refetch();
  };

  const onDeleteConfirm = async () => {
    try {
      // if (selectedRowKeys.length === 1) {
      //   await deleteData();
      // } else {
      await deleteMultiple({ ids: selectedRowKeys });
      // }
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      refetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data?.data?.map((el) => ({
        ...el,
        key: el?.ProxyNo,
      }));
      setListData(newData);
    }
  }, [data, loading]);

  // const handleExportClick = async () => {
  //   try {
  //     const freshData = await refetchExport();
  //     if (freshData) {
  //       const location = window.location;
  //       downloadCsv(freshData, location);
  //       openConfirmNotification("Success");
  //     } else {
  //       throw new Error("No export data found");
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     openErrorNotification("Something went wrong.");
  //   }
  // };

  // console.log({ listData });

  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems} />
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <div className="mb-4">
          <div className="mt-2">
            <Row gutter={[16, 16]}>
              {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                <Input
                  className="input_text_3 mr10"
                  name="ProxyNo"
                  placeholder="No"
                  value={filter.ProxyNo}
                  onChange={handleFilterChange}
                />
              </Col> */}
              <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
                <Input
                  className="input_text_3 mr10 h-full"
                  placeholder="Proxy Address"
                  value={filter.ProxyAddr}
                  onChange={handleFilterChange}
                  name="ProxyAddr"
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
                <Input
                  className="input_text_3 mr10 h-full"
                  placeholder="IP Address"
                  value={filter.Address}
                  onChange={handleFilterChange}
                  name="Address"
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
                <Input
                  className="input_text_3 mr10 h-full"
                  placeholder="Proxy Port"
                  value={filter.ProxyPort}
                  // onChange={handleFilterChange}
                  onChange={(e) => {
                    const { value } = e.target;
                    // Allow only positive integers or empty string
                    if (/^[1-9]\d*$/.test(value) || value === "") {
                      handleFilterChange(e);
                    }
                  }}
                  name="ProxyPort"
                />
              </Col>
              <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                <Select
                  showSearch
                  placeholder="Proxy Type"
                  optionFilterProp="ProxyType"
                  value={
                    typeof filter.ProxyType === "number"
                      ? filter.ProxyType
                      : null
                  }
                  onChange={(value) =>
                    setFilter({ ...filter, ProxyType: value })
                  }
                  options={ProxyTypeOptions}
                  style={{ width: "100%" }}
                />
              </Col>
              {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                <Select
                  showSearch
                  placeholder="Site Type"
                  optionFilterProp="SiteType"
                  value={filter.SiteType ? Number(filter.SiteType) : null}
                  onChange={(value) =>
                    setFilter({ ...filter, SiteType: value })
                  }
                  options={modifiedSiteTypes}
                  style={{ width: "100%" }}
                />
              </Col> */}
            </Row>
          </div>

          <div className="w-full overflow-x-auto">
            <div className="flex justify-between mt-4 flex-nowrap min-w-[610px]">
              <div className="flex items-center gap-0">
                <Button
                  type="primary"
                  className="mr-2 w-[104px] h-[30px] font-medium"
                  onClick={handleFilter}
                >
                  <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
                  Apply
                </Button>
                <Button className="reset-button" onClick={handleReset}>
                  <HiArrowPath className="!text-[14px] font-medium" />
                  Reset
                </Button>
                <Button
                  type="primary"
                  className="mr-2 -ml-2 w-[104px] h-[30px] font-medium"
                  onClick={() => navigate("/proxyserver/add")}
                >
                  <PlusOutlined />
                  Add
                </Button>
                <Button
                  type="primary"
                  disabled={selectedRowKeys?.length === 0 ? true : false}
                  className="mr-2 w-[104px] h-[30px] font-medium"
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  <DeleteOutlined />
                  Delete
                </Button>
              </div>
            </div>
          </div>
        </div>
        <ConfirmModal
          showModal={showModal}
          setShowModal={setShowModal}
          onDeleteConfirm={onDeleteConfirm}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <GlobalTable
          columns={ProxyColumns(
            hoveredRow,
            setShowModal,
            setSelectedRowKeys,
            setParams,
            params
          )}
          dataSource={listData}
          rowSelection={rowSelection}
          pagination={paginationConfig}
          onRow={(record, rowIndex) => {
            return {
              onMouseEnter: () => setHoveredRow(rowIndex),
              onMouseLeave: () => setHoveredRow(null),
              ...onRow?.(record, rowIndex),
            };
          }}
          loading={loading}
        />
      </div>
    </div>
  );
};
